import StarterKit from '@tiptap/starter-kit';

import { clsx } from '~/styles/utils';

import { linkStyle } from '../Link/Link.css';
import {
  boldStyle,
  bulletListStyle,
  dropcursorStyle,
  editorLinkStyle,
  italicStyle,
  listItemStyle,
  listStyle,
  orderedListStyle,
  paragraphStyle,
  underlineStyle,
} from './extensions.css';

export const extensions = (mode: 'editor' | 'renderer') => [
  StarterKit.configure({
    // Nodes
    paragraph: { HTMLAttributes: { class: paragraphStyle } },
    bulletList: { HTMLAttributes: { class: clsx(listStyle, bulletListStyle) } },
    orderedList: { HTMLAttributes: { class: clsx(listStyle, orderedListStyle) } },
    listItem: { HTMLAttributes: { class: listItemStyle } },
    blockquote: false,
    codeBlock: false,
    heading: false,
    horizontalRule: false,

    // Marks
    bold: { HTMLAttributes: { class: boldStyle } },
    italic: { HTMLAttributes: { class: italicStyle } },
    underline: { HTMLAttributes: { class: underlineStyle } },
    link: {
      autolink: true,
      linkOnPaste: true,
      openOnClick: false,
      shouldAutoLink: (url) => url.startsWith('https://'),
      HTMLAttributes: { class: mode === 'editor' ? editorLinkStyle : linkStyle },
    },
    code: false,
    strike: false,

    // Functionality
    dropcursor: { class: dropcursorStyle },
    gapcursor: false,
    trailingNode: false,
  }),
];
